import React, { useState } from "react";
import { Alert, Box, Button, TextField } from "@mui/material";
import { Link, useHistory, useLocation } from "react-router-dom";

import { changeRequiredNetworkPortalPassword } from "../../services/coreNetworkPortal";
import TalentAuthLayout from "./TalentAuthLayout";
import { resolveTalentReturnTo } from "./talentReturnTo";

const TALENT_LOGIN_IMAGE_URL = "https://images.pexels.com/photos/17771078/pexels-photo-17771078.jpeg";
const PASSWORD_RULES = [
  "At least 8 characters",
  "At least one uppercase letter",
  "At least one lowercase letter",
  "At least one number",
  "At least one special character",
];

export default function TalentChangePassword() {
  const history = useHistory();
  const location = useLocation();
  const returnTo = resolveTalentReturnTo(location.search);
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();
    if (password !== confirmPassword) {
      setError("Password confirmation does not match.");
      return;
    }
    try {
      setLoading(true);
      setError("");
      await changeRequiredNetworkPortalPassword({ currentPassword, password, confirmPassword });
      setCurrentPassword("");
      setPassword("");
      setConfirmPassword("");
      setMessage("Password updated successfully.");
      setTimeout(() => history.replace(returnTo), 800);
    } catch (changeError) {
      setPassword("");
      setConfirmPassword("");
      setError(changeError?.response?.data?.message || changeError.message || "Unable to change password.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <TalentAuthLayout imageUrl={TALENT_LOGIN_IMAGE_URL} imagePosition="center 42%">
      <Box component="form" onSubmit={handleSubmit}>
        <header>
          <span className="talent-auth-kicker">Talent Portal</span>
          <h1 className="talent-auth-heading">Change Temporary Password</h1>
          <p className="talent-auth-copy">
            Create a new Talent Portal password before continuing to your account.
          </p>
        </header>
        <Box aria-live="polite">
          {message ? <Alert className="talent-auth-alert" severity="success">{message}</Alert> : null}
          {error ? <Alert className="talent-auth-alert" severity="error">{error}</Alert> : null}
        </Box>
        <div className="talent-auth-fields">
          <TextField label="Current temporary password" type="password" value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} required fullWidth autoComplete="current-password" />
          <TextField label="New password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} required fullWidth autoComplete="new-password" />
          <TextField label="Confirm new password" type="password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} required fullWidth autoComplete="new-password" />
          <Alert severity="info">
            {PASSWORD_RULES.join(" • ")}
          </Alert>
          <Button className="talent-auth-submit" type="submit" variant="contained" disabled={loading}>
            {loading ? "Saving..." : "Change Password"}
          </Button>
        </div>
        <nav className="talent-auth-links" aria-label="Talent account navigation">
          <Button component={Link} to="/talent/forgot-password" size="small">Request a reset link</Button>
        </nav>
      </Box>
    </TalentAuthLayout>
  );
}
